<template>
    <div>
        <nav :class="'navbar' + ((navbarClass) ? ' ' + navbarClass : '')">
            <div class="custom-container">
                <div class="row">
                    <div class="col-lg-12 d-flex">
                        <router-link to="/"><img :src="((navbarClass) ? '/img/logo-white.svg' : '/img/logo.svg')" class="logo"></router-link>
                        <div class="align-self-center ms-auto" v-if="showButton">
                            <router-link :to="'/onderzoeken/' + this.$route.params.token" class="btn btn-sm btn-red flex-nowrap">Overzicht van onderzoeken <i class="fi fi-rr-unlock"></i></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name:  'Navigation',
    props: [
        'navbarClass'
    ],

    data() {
        return {
            showButton: false
        }
    }
}
</script>
